import React from "react";

import Link from "../../Link";
import TrudatVoteButtons from "../../Article/Content/body/TrudatVoteButtons";

export default class TrudatQuote extends React.Component {
  render() {
    var settings = this.props.settings.settings,
      url = !settings ? "" : settings.link,
      bi = !settings ? "" : settings["background-image"],
      thumbnailSize = "220,220,1,0";
    
    bi = window.MEDIA_DOMAIN + "/" + bi.replace(".", "," + thumbnailSize + ".");

    return (
      <div className="hp__block hp__block__quote container">
        <div className="col-md-12">
          <div className="hp__block__quote-border" data-post-url={url}>
            <div className="hp__block__quote-wrapper row">
              <div className="hp__block__quote__picture-round col-md-3 text-center">
                <img
                  src={bi}
                  alt={
                    !settings ? "Dodaj zdjęcie (1x1) w ustawieniach sekcji" : ""
                  }
                />
                <p>
                  {" "}
                  {!settings
                    ? "Dodaj podpis w ustawieniach sekcji"
                    : settings.quote_name}
                </p>
              </div>
              <div className="hp__block__quote-paragraph col-md-9">
                <p>
                  {" "}
                  {!settings
                    ? "Dodaj cytat w ustawieniach sekcji"
                    : settings.quote_body}{" "}
                </p>
              </div>
            </div>
            <div className="hp__block__quote-opinion text-center">
              <div className="trudat-vote">
                <h3> A Ty jak myślisz? </h3>
                <TrudatVoteButtons url={url} />
              </div>
              <div className="hp__block__quote-opinion-last-link">
                <Link to={url}>
                  {" "}
                  Przeczytaj jak jest naprawdę
                  <img
                  	alt=""
                    src={window.STATIC_DOMAIN + "/gfx/trudat/circle.jpg"}
                    className="hp__block__quote-opinion-last-link-circle"
                  />
                  <img
                  	alt=""
                    src={window.STATIC_DOMAIN + "/gfx/trudat/arrow_right.jpg"}
                    className="hp__block__quote-opinion-last-link-arrow"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
